import React from "react";
import { dataset, fileUrlFor, projectId, urlFor } from "../../utils/utils";

import "./icon.scss";

interface IProps {
  title?: string;
  icon: {
    asset: {
      _ref: string;
    };
  };
  body?: any;
}

export const Icon = (props: IProps) => {
  // console.log("VIDEOOO", props);
  // const idElements = props.asset._ref.split("-");
  // const idElements = props.icon?.asset._ref.split("-") || ["", ""];
  // const url = `https://cdn.sanity.io/files/${projectId}/${dataset}/${idElements[1]}.${idElements[2]}`;
  return (
    <div className="icon-item">
      {/* <video src={url} muted autoPlay loop playsInline /> */}
      <img
        src={(props.image && urlFor(props.image).url()) || ""}
        loading="lazy"
        alt={props.title}
      />
      <span>{props.title}</span>
    </div>
  );
};
